/**
 * Normalize MongoDB ids from API responses or localStorage to a hex string.
 */
export function normalizeId(id) {
  if (id == null) return null;
  if (typeof id === "string") {
    const trimmed = id.trim();
    if (/^[a-f0-9]{24}$/i.test(trimmed)) return trimmed;
    if (trimmed === "[object Object]") return null;
    return trimmed;
  }
  if (typeof id === "object") {
    if (typeof id.$oid === "string") return id.$oid;
    if (typeof id.toHexString === "function") return id.toHexString();
    if (id._id != null) return normalizeId(id._id);
  }
  const asString = String(id);
  return asString === "[object Object]" ? null : asString;
}

export function getActiveOrganizationName() {
  const activeId = getActiveOrganizationId();
  if (!activeId) return null;
  const organizations = localStorage.getItem("organizations")
    ? JSON.parse(localStorage.getItem("organizations"))
    : [];
  const active = organizations.find((org) => normalizeId(org.id) === activeId);
  return active?.name || null;
}

export function getActiveOrganizationId() {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : {};
  const fromUser = normalizeId(user.activeOrganizationId);
  if (fromUser && /^[a-f0-9]{24}$/i.test(fromUser)) return fromUser;

  const organizations = localStorage.getItem("organizations")
    ? JSON.parse(localStorage.getItem("organizations"))
    : [];
  const first = organizations[0];
  const fromOrg = first ? normalizeId(first.id) : null;
  if (fromOrg && /^[a-f0-9]{24}$/i.test(fromOrg)) return fromOrg;

  return null;
}
